import { isNativeMobile } from "@vestwell-frontend/helpers";
import { SecureStoragePlugin } from "capacitor-secure-storage-plugin";
import { connect } from "socket.io-client";
export const socketPromise = async ()=>{
    const isNative = await isNativeMobile();
    if (isNative) {
        const baseUrlObj = await SecureStoragePlugin.get({
            key: 'BASE_HERMES_URL'
        });
        const baseUrl = baseUrlObj?.value || '';
        return connect(`${baseUrl}`, {
            autoConnect: false,
            path: '/hermes',
            transports: [
                'websocket'
            ],
            withCredentials: true
        });
    } else {
        return connect({
            autoConnect: false,
            path: '/hermes',
            transports: [
                'websocket'
            ],
            withCredentials: true
        });
    }
};

//# sourceMappingURL=socketPromise.js.map